import React, { useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";
import { studyEventFormSchemaServices } from "../../../../APIServices/studyEventFormSchemaServices";
import { studyEventManagementServices } from "../../../../APIServices/CTMS/EventManagement/studyEventManagementServices";
import { isHTMLIdentifier } from "../../../../utils/universalFunction";

const DuplicateCustomEditCheckMetaForm = ({ category }) => {
  const [checkId, setCheckId] = useState("");
  const [label, setLabel] = useState("");
  const [type, setType] = useState("global");
  const [schemaId, setSchemaId] = useState("");
  const [eventId, setEventId] = useState("");
  const [fieldUnit, setFieldUnit] = useState("no");
  const [timePointId, setTimePointId] = useState("");
  const [eventRows, setEventRows] = useState([]);
  const [eventSchema, setEventSchema] = useState([]);
  const [fieldId, setFieldId] = useState("");
  const [version, setVersion] = useState("");
  const [formId, setFormId] = useState("");
  const [fieldCode, setFieldCode] = useState("");
  const [customField, setCustomField] = useState("");
  const [customFieldData, setCustomFieldData] = useState("");
  const [mainVersion, setMainVersion] = useState("");
  const [queryMessage, setQueryMessage] = useState("");
  const [formMetadataList, setFormMetadataList] = useState([]);
  const [customEditCheckList, setCustomEditCheckList] = useState([]);
  const [formFields, setFormFields] = useState([]);
  let { studyId } = useParams()
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [buttonLoader, setButtonLoader] = useState(false)

  const getStudyLevelCustomEditCheck = async (e) => {
    let data = await studyLevelFormManagementServices.getStudyLevelCustomEditCheck(
      studyId,
      category,
      "active",
    );
    setCustomEditCheckList(data?.data || []);
  };

  const getEventBasedonSchema = async (schemaId) => {
    let data = await studyEventFormSchemaServices.getEventBasedonSchema(studyId, schemaId, "all");
    setEventRows(data?.data || []);
  };

  const getEventFormSchema = async (e) => {
    let data = await studyEventFormSchemaServices.getEventFormSchema(
      "active",
      studyId
    );
    setEventSchema(data?.data || []);
  };

  const getStudyLevelFormFieldsByVersion = async (formId, version) => {
    let data = await studyLevelFormManagementServices.getStudyLevelFormFieldsByVersion(
      studyId,
      formId,
      version
    );
    if (data === "AbortError") {
      setFormFields([]);
    } else {
      setFormFields(data?.data?.formFields || []);
      let fieldData = (data?.data?.formFields || [])?.find(item => item.id === Number(fieldId))
      setCustomFieldData(fieldData)
      setFieldUnit(fieldData?.fieldUnit)
      let checkData = customEditCheckList?.find(item => item.checkId === checkId)
      if (fieldData?.type === "number" || fieldData?.type === "text") {
        if (checkData?.fieldCode && checkData?.fieldCode === fieldData?.fieldName) {
          setFieldCode(fieldData?.fieldName || "");
        } else if (checkData?.fieldCode && checkData?.fieldCode === fieldData?.fieldUnitName) {
          setFieldCode(fieldData?.fieldUnitName || "");
        } else if (checkData?.fieldCode && checkData?.fieldCode === fieldData?.referenceRangeLowerLimitName) {
          setFieldCode(fieldData?.referenceRangeLowerLimitName || "");
        } else if (checkData?.fieldCode && checkData?.fieldCode === fieldData?.referenceRangeUpperLimitName) {
          setFieldCode(fieldData?.referenceRangeUpperLimitName || "");
        } else if (checkData?.fieldCode && checkData?.fieldCode === fieldData?.referenceRangeIndicatorName) {
          setFieldCode(fieldData?.referenceRangeIndicatorName || "");
        } else if (checkData?.fieldCode && checkData?.fieldCode === fieldData?.clinicalSignificanceName) {
          setFieldCode(fieldData?.clinicalSignificanceName || "");
        } else if (checkData?.fieldCode && checkData?.fieldCode === fieldData?.customRemarkName) {
          setFieldCode(fieldData?.customRemarkName || "");
        }
      } else {
        if (checkData?.fieldCode && checkData?.fieldCode === fieldData?.fieldName) {
          setFieldCode(fieldData?.fieldName || "");
        } else if (checkData?.fieldCode && checkData?.fieldCode === fieldData?.referenceRangeLowerLimitName) {
          setFieldCode(fieldData?.referenceRangeLowerLimitName || "");
        } else if (checkData?.fieldCode && checkData?.fieldCode === fieldData?.referenceRangeUpperLimitName) {
          setFieldCode(fieldData?.referenceRangeUpperLimitName || "");
        } else if (checkData?.fieldCode && checkData?.fieldCode === fieldData?.referenceRangeIndicatorName) {
          setFieldCode(fieldData?.referenceRangeIndicatorName || "");
        } else if (checkData?.fieldCode && checkData?.fieldCode === fieldData?.clinicalSignificanceName) {
          setFieldCode(fieldData?.clinicalSignificanceName || "");
        } else if (checkData?.fieldCode && checkData?.fieldCode === fieldData?.customRemarkName) {
          setFieldCode(fieldData?.customRemarkName || "");
        }
      }
    }
  };

  const getSchemaEventForms = async (schemaId, eventId, timePointId, formId, version) => {
    let data = await studyEventManagementServices.getSchemaEventForms(
      studyId,
      schemaId,
      eventId,
      timePointId || "no", StudyMode
    );
    setFormMetadataList(data?.data || []);
    let formData = (data?.data || [])?.find(item => item.formId === formId)
    if (formData) {
      setFormId(formData?.formId)
      setMainVersion(formData?.version)
      getStudyLevelFormFieldsByVersion(formData?.formId, version)
    }
  };

  const LoginCat = JSON.parse(localStorage.getItem("role")).toLowerCase();

  const getStudyLevelForm = async (formId, version) => {
    let data = await studyLevelFormManagementServices.getStudyLevelForm(
      studyId,
      LoginCat,
      "active",
      StudyMode
    );
    setFormMetadataList(data?.data || []);
    let formData = (data?.data || [])?.find(item => item.formId === formId)
    if (formData) {
      setFormId(formData?.formId)
      setMainVersion(formData?.version)
      getStudyLevelFormFieldsByVersion(formData?.formId, version)
    }
  };

  const duplicateStudyLevelCustomEditCheck = async () => {
    setButtonLoader(true)
    let userData = {}
    userData.studyId = studyId
    userData.previousCheckId = checkId
    userData.label = label
    userData.type = type
    if (type === "byEvent") {
      userData.schemaId = schemaId
      userData.eventId = eventId
      userData.timePointId = timePointId
    }
    userData.formId = formId
    userData.fieldId = fieldId
    userData.customField = customField
    userData.fieldCode = fieldCode
    userData.version = version
    userData.category = category
    userData.queryMessage = queryMessage
    let data = await studyLevelFormManagementServices.duplicateStudyLevelCustomEditCheck(userData)
    if (data?.statusCode === 200) {
      clearForm()
      getStudyLevelCustomEditCheck()
    }
    setButtonLoader(false)
  }

  useEffect(() => {
    if (formId && version) {
      getStudyLevelFormFieldsByVersion(formId, version)
    }
  }, [formId, version]);

  const clearForm = () => {
    setCheckId("")
    setLabel("")
    setFieldId("")
    setType("global")
    setSchemaId("")
    setEventId("")
    setTimePointId("")
    setEventRows([])
    setEventSchema([])
    setFormId("")
    setVersion("")
    setCustomField("")
    setFieldCode("")
    setCustomFieldData("")
    setMainVersion("")
    setQueryMessage("")
    setFormFields([])
  }

  useEffect(() => {
    if (!checkId) {
      clearForm();
    }
  }, [checkId]);

  const selectedPreviousForm = (previousCheckId) => {
    setCheckId(previousCheckId)
    let selectedData = customEditCheckList?.find(item => item.checkId === previousCheckId)
    setLabel(selectedData?.label)
    setCustomField(selectedData?.customField)
    setType(selectedData?.type)
    setSchemaId(selectedData?.schemaId || "")
    if (selectedData?.type === "byEvent") {
      getEventFormSchema()
    } else {
      getStudyLevelForm(selectedData?.formId, selectedData?.version)
    }
    if (selectedData?.schemaId) {
      getEventBasedonSchema(selectedData?.schemaId)
    }
    setEventId(selectedData?.eventId || "")
    setTimePointId(selectedData?.timePointId || "")
    if (selectedData?.schemaId && selectedData?.eventId) {
      getSchemaEventForms(selectedData?.schemaId, selectedData?.eventId, selectedData?.timePointId, selectedData?.formId, selectedData?.version)
    }
    setVersion(selectedData?.version)
    setFieldId(selectedData?.fieldId)
    setQueryMessage(selectedData?.queryMessage)
  }

  const selectFormFieldData = (fieldId) => {
    setFieldId(fieldId)
    let fieldData = formFields?.find(item => item.id === Number(fieldId))
    setCustomFieldData(fieldData)
    if (fieldData?.type === "number" || fieldData?.type === "text") {
      let twoFieldCode = [
        { fieldCode: fieldData?.fieldName },
        { fieldUnitCode: fieldData?.fieldUnitName }
      ];
      for (const item of twoFieldCode) {
        if (item.fieldCode === fieldCode) {
          setFieldCode(fieldData?.fieldUnitName)
          break;
        } else if (item.fieldUnitCode === fieldCode) {
          setFieldCode(fieldData?.fieldName)
          break;
        }
      }
    } else {
      setFieldCode(fieldData?.fieldName)
    }
  }

  useEffect(() => {
    clearForm();
    getStudyLevelCustomEditCheck()
  }, []);

  return (
    <div className="p-2">
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Custom Edit Checks{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Select
          onChange={(e) => selectedPreviousForm(e.target.value)}
          className="br3"
          style={{ fontSize: 12 }}
        >
          <option selected={checkId === ""} value="">Select Custom Edit Check</option>
          {customEditCheckList?.map((item, index) => (
            <option key={index} selected={checkId === item?.checkId} value={item?.checkId}>{item?.label}</option>
          ))}
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Label{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Control
          onChange={(e) => setLabel(e.target.value)}
          value={label}
          className="br3"
          placeholder="Label"
          type="text"
        />
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Type{" "}
          <abbr title="required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Select
          onChange={(e) => setType(e.target.value)}
          className="br3"
          disabled
          style={{ fontSize: 12 }}
        >
          <option selected={type === "global"} value="global">Global</option>
          <option selected={type === "byEvent"} value="byEvent">By Event</option>
        </Form.Select>
      </Form.Group>
      {type === "byEvent" &&
        <>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Schema{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              onChange={(e) => setSchemaId(e.target.value)}
              style={{ fontSize: 12 }}
              disabled
              className="br3"
            >
              <option selected={schemaId === ""} value="">Select Schema</option>
              {eventSchema?.map((item, index) => (
                <option key={index} selected={schemaId === item?.schemaId} value={item?.schemaId}>{item?.schemaName}</option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Event{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              onChange={(e) => { setEventId(e.target.value); setTimePointId(e.target[e.target.selectedIndex].id) }}
              style={{ fontSize: 12 }}
              disabled
              className="br3"
            >
              <option selected={eventId === ""} value="">Select Event</option>
              {eventRows?.map((item, index) => (
                <option
                  key={index}
                  selected={
                    `${item.eventId}${item?.row?.["TIMEPOINTUNIQUEID"] || ""
                    }` === `${eventId}${timePointId || ""}`
                  }
                  value={item?.eventId}
                  id={item?.row?.["TIMEPOINTUNIQUEID"] || ""}
                >
                  {item?.row?.["EVENTID"]} {item?.row?.["TIMEPOINTUNIQUEID"] && `(${item?.row?.["TIMEPOINTID"]})`}
                </option>
              ))}
              <option selected={eventId === "specialForm"} value="specialForm" id="">Special Form</option>
            </Form.Select>
          </Form.Group>
        </>
      }
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Form{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Select
          onChange={(e) => { setFormId(e.target.value); setMainVersion(e.target[e.target.selectedIndex].title) }}
          className="br3"
          disabled
          style={{ fontSize: 12 }}
        >
          <option selected={formId === ""} value="">Select Form</option>
          {formMetadataList?.map((item, index) => (
            <option key={index} selected={formId === item?.formId} value={item?.formId} title={item?.version}>{item?.formName}</option>
          ))}
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Form Version{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Select
          onChange={(e) => setVersion(e.target.value)}
          className="br3"
          disabled
          style={{ fontSize: 12 }}
        >
          <option selected={version === ""} value="">Select Version</option>
          {Array.from({ length: mainVersion }, (_, i) => i + 1)?.reverse()?.map((versionNumber, index) => (
            <option key={index} selected={Number(version) === versionNumber} value={versionNumber}>Version {versionNumber}</option>
          ))}
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Form Field{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Select
          onChange={(e) => { selectFormFieldData(e.target.value); setFieldUnit(e.target[e.target.selectedIndex].title); setCustomField(e.target[e.target.selectedIndex].id) }}
          className="br3"
          disabled={formFields?.length === 0}
          style={{ fontSize: 12 }}
        >
          <option selected={fieldId === ""} value="">Select Field</option>
          {formFields?.map((item, index) => (
            <option key={index} selected={Number(fieldId) === item?.id} value={item?.id} id={item?.customField || "no"} title={item?.fieldUnit}>
              {isHTMLIdentifier(item?.fieldLabel || "") ? (
                <span
                  dangerouslySetInnerHTML={{
                    __html: item?.fieldLabel,
                  }}
                />
              ) : (
                item?.fieldLabel
              )}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
      {(customField === "yes" || fieldUnit === "yes") &&
        <Form.Group className="mb-1">
          <Form.Label className="fw-bold mb-1">
            Sub-Fields{" "}
            <abbr title="required" className="text-danger">
              *
            </abbr>
          </Form.Label>
          <Form.Select
            onChange={(e) => setFieldCode(e.target.value)}
            className="br3"
            disabled={formFields?.length === 0}
            style={{ fontSize: 12 }}
          >
            <option selected={fieldCode === ""} value="">Select Sub-Field Code</option>
            <option selected={fieldCode === customFieldData?.fieldName} value={customFieldData?.fieldName}>
              {isHTMLIdentifier(customFieldData?.fieldLabel || "") ? (
                <span
                  dangerouslySetInnerHTML={{
                    __html: customFieldData?.fieldLabel,
                  }}
                />
              ) : (
                customFieldData?.fieldLabel
              )}
            </option>
            {fieldUnit === "yes" &&
              <option selected={fieldCode === customFieldData?.fieldUnitName} value={customFieldData?.fieldUnitName}>{customFieldData?.fieldUnitLabel}</option>
            }
            {customField === "yes" &&
              <>
                {customFieldData?.referenceRangeLowerLimit === "yes" &&
                  <option selected={fieldCode === customFieldData?.referenceRangeLowerLimitName} value={customFieldData?.referenceRangeLowerLimitName}>{customFieldData?.referenceRangeLowerLimitLabel}</option>
                }
                {customFieldData?.referenceRangeUpperLimit === "yes" &&
                  <option selected={fieldCode === customFieldData?.referenceRangeUpperLimitName} value={customFieldData?.referenceRangeUpperLimitName}>{customFieldData?.referenceRangeUpperLimitLabel}</option>
                }
                {customFieldData?.referenceRangeIndicator === "yes" &&
                  <option selected={fieldCode === customFieldData?.referenceRangeIndicatorName} value={customFieldData?.referenceRangeIndicatorName}>{customFieldData?.referenceRangeIndicatorLabel}</option>
                }
                {customFieldData?.clinicalSignificance === "yes" &&
                  <option selected={fieldCode === customFieldData?.clinicalSignificanceName} value={customFieldData?.clinicalSignificanceName}>{customFieldData?.clinicalSignificanceLabel}</option>
                }
                {customFieldData?.customRemark === "yes" &&
                  <option selected={fieldCode === customFieldData?.customRemarkName} value={customFieldData?.customRemarkName}>{customFieldData?.customRemarkLabel}</option>
                }
              </>
            }
          </Form.Select>
        </Form.Group>
      }
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Query Message{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Control
          onChange={(e) => setQueryMessage(e.target.value)}
          value={queryMessage}
          className="br3"
          placeholder="Query Message"
          as="textarea"
        />
      </Form.Group>
      <div className="text-end">
        <button
          disabled={
            type === "byEvent" ?
              (!checkId || !label || !type || !schemaId || !eventId || !formId || !fieldCode || !customField || !fieldId || !version || !queryMessage || buttonLoader)
              :
              (!checkId || !label || !type || !formId || !fieldCode || !customField || !fieldId || !version || !queryMessage || buttonLoader)
          }
          onClick={duplicateStudyLevelCustomEditCheck}
          className="updateProfile"
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Duplicating...
            </div>
          ) : (
            "Duplicate Check Meta"
          )}
        </button>
      </div>
    </div>
  );
};

export default DuplicateCustomEditCheckMetaForm;
